/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/play';
import { PLAY } from '@/store/types';
import { PlayService } from '@/api/types/play';
import { finalizeAction, StoreActionEnv, ActionType } from '@/store/actions';

export interface StorePlayServiceDetailState {
  id: number;
  scene: string;
  service: PlayService;
}

export default {
  namespaced: true,
  state: {
    id: null,
    scene: null,
    service: null,
  },
  getters: {},
  actions: {
    [PLAY.GET_SERVICE](
      { state, commit }: StoreActionEnv<StorePlayServiceDetailState>,
      { id, scene = '', action: rawAction }: { id: number; scene: string; action: ActionType },
    ) {
      const action = finalizeAction(rawAction, state.id === id && state.scene === scene);
      if (action) {
        return new Promise((resolve, reject) => {
          api.getService(id, scene).then((res) => {
            commit(PLAY.GET_SERVICE, { id, scene, data: res.data });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [PLAY.GET_SERVICE](
      state: StorePlayServiceDetailState,
      { id, scene, data }: { id: number; scene: string; data: PlayService },
    ) {
      state.id = id;
      state.scene = scene;
      state.service = data;
    },
  },
};
